<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: "Figtree", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h3{
  font-weight: 600 !important;
  font-size: 40px !important;
  line-height: 1.1;
}
h4{
  font-weight: 600 !important;
  font-size: 30px !important;
  margin-bottom: 25px !important;
  line-height: 100%;
  letter-spacing: 0%;
}
p{
  font-size: 20px;
  line-height: 1.2;
}


.samara .phoneCoto{
  display: none !important;
}

/* -------------  WHATSAPP ------------- */
.whatsapp{
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 60px !important;
}
.whatsapp img{
    width: 100%;
}
.whatsapp .btn{
  border: none !important;
  background: transparent !important;
  padding: 0;
}


.dropdown-menu,
.dropdown-item{
  border: none !important;
  color: #fff !important;
}
.dropdown-item:hover, .dropdown-item:focus{
  background: transparent !important;
}
.transparent  .dropdown-menu{
    background: #20234A66 !important;
}
.light  .dropdown-menu{
    background: #20234A !important;
}

/* SLICK NOSOTROS */
.carrouselNosotros .slick-next:before{
  content: url('./assets/imgs/next.png');
  opacity: 1 !important;
}
.carrouselNosotros .slick-next{
  right: -4% !important;
  opacity: 1 !important;
}
.carrouselNosotros .slick-prev:before{
  content: url('./assets/imgs/previo.png');
  opacity: 1 !important;
}
.carrouselNosotros .slick-prev{
  left: -7% !important;
  z-index: 2;
  opacity: 1 !important;
}

/* SLICK ASSETS */
.assets .slick-next{
  right: 5% !important;
  opacity: 1 !important;
}
.assets .slick-next:before{
  content: url('./assets/imgs/next.png');
  opacity: 1 !important;
}
.assets .slick-prev{
  left: 5% !important;
  z-index: 2;
  opacity: 1 !important;
}
.assets .slick-prev:before{
  content: url('./assets/imgs/previo.png');
  opacity: 1 !important;
}

.modal-body{
  padding: 0 !important;
}

/* MODAL FOLLETO */
#modal-center .modal-content{
  border-radius: 20px !important;
  border: none !important;
}
#modal-center.eliza .modal-body{
  padding: 0;
  background: #C5C297;
  border: none !important;
  border-radius: 20px !important;
}
#modal-center.isa .modal-body{
  padding: 0;
  background: #BED3D8;
  border: none !important;
  border-radius: 20px !important;
}
#modal-center.ale .modal-body{
  padding: 0;
  background: #D9BEA5;
  border: none !important;
  border-radius: 20px !important;
}

.transparent .navbar-light .navbar-toggler-icon,
.contactopage .navbar-light .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}
@media (max-width: 992px) {
  .assets .slick-next{
    right: 12% !important;
  }
  .assets .slick-prev{
    left: 7% !important;
  }
  .carrouselNosotros .slick-next{
    right: 12% !important;
  }
  .carrouselNosotros .slick-prev{
    left: 7% !important;
  }
}
@media (max-width: 768px) {
  h3{
    font-size: 35px !important;
  }
  h4{
    font-size: 28px !important;
  }
  p{
    font-size: 18px;
  }
}
</style>
